export interface IEnumSet {
  [key: string]: {
    value: any,
    description?: string
  }
}

/**
 * Create a simple implementation of an Enum with some utility methods
 */
class EnumSet {
  $keyList: {}

  /**
   * Creates an instance of EnumSet.
   * @param {EnumSet} objList An object list with an value or description
   */
  constructor(objList: IEnumSet) {
    this.$keyList = {}

    for (let [key, prop] of Object.entries(objList)) {
      this[key] = prop.value
      this.$keyList[key] = prop.description || key
    }
  }

  /**
   * Returns the descripton of an enum
   * @param {string} key The enum to be described
   */
  getDescription(key) {
    return this.$keyList[key] || null
  }

  /**
   * Returns the key of an enum by its value
   * @param {*} value The enum value to be searched
   */
  getKeyByValue(value) {
    const reduceKey = (accumulator, key) => {
      accumulator = this[key] !== value
        ? accumulator
        : key

      return accumulator
    }

    return Object.keys(this).reduce(reduceKey, '') || null
  }

  /**
   * Returns the description of an enum by its value
   * @param {*} value The enum value to be searched
   */
  getDescriptionByValue(value) {
    const key = this.getKeyByValue(value)

    return this.$keyList[key] || null
  }

  /**
   * Returns a list of object with enums value and description
   * @param {string} [value='value'] The name to replace the value key
   * @param {string} [description='description'] The name to replace the description key
   */
  toList(value = 'value', description = 'description') {
    return Object.keys(this.$keyList).map(key => ({
      key,
      [value]: this[key],
      [description]: this.$keyList[key]
    }))
  }

  toTuple(key) {
    const value = this[key]
    const description = this.$keyList[key]

    return [value, description ]
  }
}

export { EnumSet as default }